"use client";

import React, { useEffect, useState, useRef } from "react";
import { cn } from "@/utils/cn";

const items = [
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/04/36.png',
        mediaItemId: 1063,
        altText: 'Mellow & Banana'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/rapppicard.png',
        mediaItemId: 1065,
        altText: 'Rappi'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/35.png',
        mediaItemId: 542,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/34.png',
        mediaItemId: 541,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/37.png',
        mediaItemId: 539,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/18.png',
        mediaItemId: 533,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/13.png',
        mediaItemId: 526,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/15.png',
        mediaItemId: 528,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/11.png',
        mediaItemId: 525,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/14.png',
        mediaItemId: 527,
        altText: ''
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/23.png',
        mediaItemId: 293,
        altText: 'Mercado Libre'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/25.png',
        mediaItemId: 295,
        altText: 'wework'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/26.png',
        mediaItemId: 292,
        altText: 'Davivienda'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/27.png',
        mediaItemId: 297,
        altText: 'Derco'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/28.png',
        mediaItemId: 298,
        altText: 'Domenica'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/29.png',
        mediaItemId: 299,
        altText: 'Grupo Exito'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/30.png',
        mediaItemId: 300,
        altText: 'SBS'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/32.png',
        mediaItemId: 302,
        altText: 'Sistecredito'
      }
    }
  },
  {
    clientesAliados: {
      clientesaliado: {
        mediaItemUrl: 
          'https://test.mincaelectric.com/wp-content/uploads/2024/03/33.png',
        mediaItemId: 303,
        altText: 'Vanti'
      }
    }
  }
]

export const InfiniteMovingCards = ({
  direction = "left",
  speed = "slow",
  pauseOnHover = true,
  className,
}) => {
  const containerRef = useRef(null);
  const scrollerRef = useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    addAnimation();
  }, []);

  const addAnimation = () => {
    if (containerRef.current && scrollerRef.current) {
      const scrollerContent = Array.from(scrollerRef.current.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        scrollerRef.current.appendChild(duplicatedItem);
      });

      getDirection();
      getSpeed();
      setStart(true);
    }
  };

  const getDirection = () => {
    if (containerRef.current) {
      if (direction === "left") {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "forwards",
        );
      } else {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "reverse",
        );
      }
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      if (speed === "fast") {
        containerRef.current.style.setProperty("--animation-duration", "20s");
      } else if (speed === "normal") {
        containerRef.current.style.setProperty("--animation-duration", "40s");
      } else {
        containerRef.current.style.setProperty("--animation-duration", "380s");
      }
    }
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        "scroller relative z-20  w-full overflow-hidden  [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]",
        className,
      )}
    >
      <ul
        ref={scrollerRef}
        className={cn(
          " flex w-max min-w-full shrink-0 flex-nowrap gap-4 py-4",
          start && "animate-scroll ",
          pauseOnHover && "hover:[animation-play-state:paused]",
        )}
      >
        {items.map((item, idx) => (
          <li
            className="  relative flex justify-center items-center py-2 h-[70px] w-[150px] rounded-[5px] bg-[#F0EEED] lg:h-[75px] lg:w-[191px] 2xl:h-[105px] 2xl:w-[270px]"
            key={`infinite-moving-card-${idx}`}
          >
            <div className="grid place-items-center">
              <div
                aria-hidden="true"
                className="user-select-none -z-1 pointer-events-none grid place-items-center"
              >
                <img
                  className="h-auto w-[90px] lg:h-[57px] lg:w-[143px] "
                  src={item.clientesAliados.clientesaliado.mediaItemUrl}
                  alt="Clientes relacionados"
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
